<template>
  <div v-loading="isLoading" class="loading-container"></div>
</template>
<script>
export default {
  name: "PaymentBidv",
  computed: {},
  components: {},
  props: {},

  data() {
    return {
      isLoading: true
    };
  },
  created() {
    console.log("this", this.$route.query.data);

    setTimeout(() => {
      console.log("chạy vào đây");

      this.loadingData = false;
      this.$router.go(-1);
    }, 1000 * 90);
  },
  mounted() {},
  beforeDestroy() {},
  methods: {}
};
</script>

<style scoped>
.loading-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
</style>
